<template>
  <div>
    <template v-if="myself">
      <v-row justify="space-between">
        <v-col cols="4">
          <v-checkbox
              v-model="ownerView.publishing"
              label="事業者情報を公開する"
              v-if="editable">
          </v-checkbox>
          <v-row dense align="center" v-else>
            <readonly-checkbox :value="ownerView.publishing"></readonly-checkbox>
            <span class="v-label ml-2">事業者情報を公開する</span>
          </v-row>
        </v-col>
        <v-col cols="4" :style="{minWidth: '270px'}">
          <v-sheet dark rounded class="owner-permission" color="grey darken-3">
            <v-simple-table dense :style="{backgroundColor: 'transparent'}">
              <tbody>
                <tr v-if="ownerView.componentOwner">
                  <th>外部辞書作成権限:</th>
                  <td><readonly-checkbox value color="white"/></td>
                </tr>
                <tr v-if="ownerView.platformOwner">
                  <th>共通辞書作成権限:</th>
                  <td><readonly-checkbox value color="white"/></td>
                </tr>
                <tr v-if="!ownerView.componentOwner && !ownerView.platformOwner">
                  <th>権限なし</th>
                  <td><readonly-checkbox color="white"/></td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-sheet>
        </v-col>
      </v-row>
      <v-divider class="mt-3"/>
    </template>

    <v-row class="mt-5">
      <v-col>
        <text-field-like
            :value="ownerView.id"
            label="事業者ID"
            hide-details>
        </text-field-like>
      </v-col>

      <v-col>
        <text-field-like
            v-model="ownerView.name"
            label="事業者名"
            :placeholder="editable ? '' : '未設定'"
            hide-details>
        </text-field-like>
      </v-col>

      <v-col>
        <v-text-field
            v-if="editable"
            v-model="ownerView.nameKatakana"
            label="事業者名カナ"
            hide-details>
        </v-text-field>
        <text-field-like
            v-else
            v-model="ownerView.nameKatakana"
            label="事業者名カナ"
            placeholder="未設定"
            hide-details>
        </text-field-like>
      </v-col>

      <v-col>
        <v-text-field
            v-if="editable"
            v-model="ownerView.nameEnglish"
            label="英語名"
            hide-details>
        </v-text-field>
        <text-field-like
            v-else
            v-model="ownerView.nameEnglish"
            label="英語名"
            placeholder="未設定"
            hide-details>
        </text-field-like>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
            v-if="editable"
            v-model="ownerView.url"
            label="URL"
            hide-details>
        </v-text-field>
        <text-field-like
            v-else
            v-model="ownerView.url"
            label="URL"
            placeholder="未設定"
            hide-details>
          <template #default="{value: url}">
            <template v-if="isUrl(url)">
              <a :href="url" target="_blank">{{ url }}</a>
            </template>
            <template v-else>
              {{ url }}
            </template>
          </template>
        </text-field-like>
      </v-col>
    </v-row>

    <template v-if="showDetail">
      <v-row>
        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.corporateNumber"
              label="法人番号"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.corporateNumber"
              label="法人番号"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-select
              v-model="ownerView.industry"
              :items="industries"
              label="業種"
              :readonly="!editable"
              :placeholder="editable ? '' : '未設定'"
              hide-details>
          </v-select>
        </v-col>

        <v-col>
          <v-select
              v-model="ownerView.scale"
              :items="scales"
              label="規模"
              :readonly="!editable"
              :placeholder="editable ? '' : '未設定'"
              hide-details>
          </v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2">
          <v-text-field
              v-if="editable"
              v-model="ownerView.postCode"
              label="郵便番号"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.postCode"
              label="郵便番号"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>

        <v-col cols="2">
          <v-autocomplete
              v-if="editable"
              v-model="ownerView.location"
              label="所在地"
              :items="locations"
              hide-details>
          </v-autocomplete>
          <text-field-like
              v-else
              v-model="ownerView.location"
              label="所在地"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>

        <v-col cols="8">
          <v-text-field
              v-if="editable"
              v-model="ownerView.address"
              label="住所"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.address"
              label="住所"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.staff"
              label="担当者名"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.staff"
              label="担当者名"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>

        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.department"
              label="部署"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.department"
              label="部署"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>

        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.staffMail"
              label="E-mail"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.staffMail"
              label="E-mail"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.staffTel"
              label="TEL"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.staffTel"
              label="TEL"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>

        <v-col>
          <v-text-field
              v-if="editable"
              v-model="ownerView.staffFax"
              label="FAX"
              hide-details>
          </v-text-field>
          <text-field-like
              v-else
              v-model="ownerView.staffFax"
              label="FAX"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>
    </template> <!-- v-if="showDetail" -->
    <template v-else>
      <v-row>
        <v-col cols="2">
          <v-autocomplete
              v-if="editable"
              v-model="ownerView.location"
              :items="locations"
              label="所在地"
              hide-details>
          </v-autocomplete>
          <text-field-like
              v-else
              v-model="ownerView.location"
              label="所在地"
              placeholder="未設定"
              hide-details>
          </text-field-like>
        </v-col>
      </v-row>
    </template>

    <v-row>
      <v-col>
        <v-textarea
            v-if="editable"
            v-model="ownerView.description"
            label="説明"
            messages="複数行入力可"
            rows="1"
            auto-grow>
        </v-textarea>
        <text-field-like
            v-else
            v-model="ownerView.description"
            label="説明"
            placeholder="未設定"
            multi-line>
        </text-field-like>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { INDUSTRIES, SCALES, LOCATIONS } from "@/constants";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
import {mapGetters} from "vuex";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";

const urlRegexp = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/;

export default {
  name: 'OwnerForm',
  components: {TextFieldLike, ReadonlyCheckbox},
  model: {
    prop: 'owner',
    event: 'change-form'
  },
  props: {
    owner: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      ownerView: {}
    };
  },
  computed: {
    ...mapGetters({
      account: 'account'
    }),
    industries: () => INDUSTRIES.map(p => ({ text: p, value: p })),
    scales: () => SCALES.map(p => ({ text: p, value: p })),
    locations: () => LOCATIONS.map(p => ({ text: p, value: p })),
    editable() {
      return !this.readonly;
    },
    myself() {
      return this.account.owner?.id === this.ownerView.id;
    },
    showDetail() {
      return this.myself || (this.ownerView.detailViewable ?? true);
    }
  },
  methods: {
    isUrl(string) {
      return urlRegexp.test(string);
    }
  },
  watch: {
    owner: {
      immediate: true,
      handler(value) {
        this.ownerView = value
      }
    },
    ownerView: {
      deep: true,
      handler() {
        this.$emit('change-form', this.ownerView)
        this.$emit('dirty')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-select .v-select__selection--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}

.owner-permission {
  padding: 5px;
}
</style>
